import "./assets/css/appearance.css";
import "./assets/css/buttons.css";
import "./assets/css/card.css";
import "./assets/css/chats.css";
import "./assets/css/forms.css";
import "./assets/css/helptip.css";
import "./assets/css/home.css";
import "./assets/css/login.css";
import "./assets/css/modals.css";
import "./assets/css/sidebar.css";
import "./assets/css/spinner.css";
import "./assets/css/table.css";
import "./assets/css/wsp.css";
import "./assets/css/facebook.css";
import { useEffect, useState } from "react";
import LoadingGlobal from "./components/LoadingGlobal";
import { getMe, logout } from "./services/auth";
import "react-toastify/dist/ReactToastify.css";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css"; //icons
import AuthRouter from "./routers/AuthRouter";
import useChatbotConfig from "./hooks/useChatbotConfig";
import { initLocaleVariables } from "./utils/utils";

function App() {
  initLocaleVariables();

  const { setLog, log, deleteToken, setUser, setBots, setBotSelected, setServer } =
    useChatbotConfig();
  const [isLoadingGlobal, setIsLoadingGlobal] = useState(true);

  const fetchData = async () => {
    setIsLoadingGlobal(true);
    try {
      const res = await getMe();
      setUser(res.user);
      setBots(res.bots);
      setServer(res.server);
      setLog(true);
      if (localStorage.getItem("bot")) {
        setBotSelected(
          res.bots.find((b) => b.id === Number(localStorage.getItem("bot")))
        );
      } else {
        localStorage.setItem("bot", res.bots[0].id);
        setBotSelected(res.bots[0]);
      }
      setIsLoadingGlobal(false);
    } catch {
      logout();
      deleteToken();
      setIsLoadingGlobal(false);
    }
  };

  useEffect(() => {
    fetchData();
    const handleSyncBotSelectedTabs = (event) => {
      if (event.key === "bot" || event.key === "jwt") {
        fetchData();
      }
    };
    window.addEventListener("storage", handleSyncBotSelectedTabs);
    return () =>
      window.removeEventListener("storage", handleSyncBotSelectedTabs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [log]);
  return <>{isLoadingGlobal ? <LoadingGlobal /> : <AuthRouter />}</>;
}

export default App;
